import { render, staticRenderFns } from "./VbgDashboardRoot.vue?vue&type=template&id=762cd996&scoped=true"
import script from "./VbgDashboardRoot.vue?vue&type=script&lang=js"
export * from "./VbgDashboardRoot.vue?vue&type=script&lang=js"
import style0 from "./VbgDashboardRoot.vue?vue&type=style&index=0&id=762cd996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762cd996",
  null
  
)

export default component.exports